import AbstractWebRtcListenerAction from "./AbstractWebRtcListenerAction";
import ListenerMessage from "../../listen/ListenerMessage";
import AbstractWebRtcCall from "~/ts/library/webRtc/AbstractWebRtcCall";

export default class NewWebRtcCallStartedByYou extends AbstractWebRtcListenerAction {
    getAction(): string {
        return "newWebRtcCallStartedByYou";
    }

    onAction(payload: CometOperatorApplication.NewWebRtcCallStartedByYouCometMessageOpenApiModel, message: ListenerMessage): void {
        let call = AbstractWebRtcCall.create(payload.call!.id)!;
        call.setCallData(payload.call!);
        if (call.isCallForThisInstance()) {
            if (call.isWebRtcSupported()) {
                AbstractWebRtcCall.setCurrentCall(call);
            } else {
                call.showWebRtcNotSupportedError();
            }
        }
    }
}